import React from 'react';
import { Link } from 'react-router-dom';

export const Breadcrumbs = ({ page, path, label }) => {
    return (
        <div className="bg-yellow-200 mt-36 md:mt-32 lg:mt-36 xl:mt-36 py-6 px-5 shadow-sm  rounded-lg">
            <div className="container mx-auto flex flex-col md:flex-row justify-between items-start md:items-center">
           
                <div className="flex justify-start items-center mb-4 md:mb-0">
                    <h2 className="text-2xl font-bold text-yellow-700">{page}</h2>
                </div>

        
                <div className="flex justify-end items-center">
                    <nav className="flex" aria-label="Breadcrumb">
                        <ol className="flex items-center space-x-2">
                            <li>
                                <Link to={path} className="text-yellow-700 hover:text-blue-800 font-semibold">
                                    {label}
                                </Link>
                            </li>
                            <li>
                                <span className="text-yellow-700">/</span>
                            </li>
                            <li>
                                <span className="text-yellow-700 font-semibold">{page}</span>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    );
};